import axios from "axios";

// API base URL resolution:
//  1. Prefer same-origin so auth cookies and ingress routing "just work" on
//     custom domains (accuratemonkey.com) AND on emergent.host deploys.
//  2. Fall back to REACT_APP_BACKEND_URL only when the page is served from
//     a different origin than the backend (rare; mainly local dev where the
//     frontend runs on :3000 but the backend on :8001).
function resolveApiBase() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return `${envUrl || ""}/api`;
  const pageOrigin = window.location.origin;
  // If env URL is missing OR matches the page origin → same-origin (relative path).
  if (!envUrl || envUrl.replace(/\/$/, "") === pageOrigin) return "/api";
  // Local dev case: page on :3000, backend on :8001 → use env URL.
  if (pageOrigin.startsWith("http://localhost")) return `${envUrl}/api`;
  // Production custom-domain case: env URL is some legacy/preview URL but the
  // user opened the site on a custom domain. Same-origin wins → cookies work.
  return "/api";
}

export const API = resolveApiBase();

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
